import { FC } from "react";

const MainLoader: FC = () => {
  return <>Loading...</>;
};

export default MainLoader;
